import { NgModule, LOCALE_ID } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxWebstorageModule } from "ngx-webstorage";
import { rootRouterConfig } from "./app.routing";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { secret } from "./app.env";
import { registerLocaleData } from "@angular/common";

import localePt from "@angular/common/locales/pt";

registerLocaleData(localePt);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    RouterModule.forRoot(rootRouterConfig, { useHash: true, relativeLinkResolution: 'legacy' }),
    NgxWebstorageModule,

    NgxWebstorageModule.forRoot({
      caseSensitive: false
    })
  ],
  declarations: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: "pt-BR" },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
